import { render } from "./add-collection.vue?vue&type=template&id=e30013c4&scoped=true"
import script from "./add-collection.vue?vue&type=script&lang=js"
export * from "./add-collection.vue?vue&type=script&lang=js"

import "./add-collection.vue?vue&type=style&index=0&id=e30013c4&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e30013c4"]])

export default __exports__